import React from "react";
import { PageLayout } from "../common";
import { TopChrome } from "../features/chrome";

export const NotFoundPage: React.FC = () => {
  return <PageLayout topChrome={<TopChrome />}>dunno.</PageLayout>;
};
